import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Pause, Play, Trash2, Clock } from "lucide-react";

export const HeldSalesDialog = ({
  open, onOpenChange,
  heldSales,
  onRelease, onDelete,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Pause className="h-5 w-5 text-orange-500" />
            Held Sales ({heldSales.length}/5)
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 max-h-[400px] overflow-y-auto">
          {heldSales.length === 0 ? (
            <div className="text-center text-slate-500 py-8">No held sales</div>
          ) : (
            heldSales.map((sale, index) => (
              <div key={sale.id} className="border rounded-lg p-3 bg-slate-50 hover:bg-slate-100 transition-colors">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded">
                      #{index + 1}
                    </span>
                    <div className="flex items-center gap-1 text-sm text-slate-500">
                      <Clock className="h-3.5 w-3.5" />
                      {sale.heldAtDisplay}
                    </div>
                  </div>
                  <div className="text-lg font-bold text-slate-800">
                    R {sale.total.toFixed(2)}
                  </div>
                </div>
                <div className="text-xs text-slate-600 mb-2 max-h-16 overflow-y-auto">
                  {sale.items.slice(0, 3).map((item, i) => (
                    <div key={i} className="flex justify-between py-0.5">
                      <span className="truncate max-w-[200px]">{item.quantity}x {item.name}</span>
                      <span className="font-mono">R {item.total.toFixed(2)}</span>
                    </div>
                  ))}
                  {sale.items.length > 3 && (
                    <div className="text-slate-400 italic">+{sale.items.length - 3} more item(s)</div>
                  )}
                </div>
                <div className="flex gap-2">
                  <Button onClick={() => onRelease(sale.id)}
                    className="flex-1 h-9 bg-cyan-500 hover:bg-cyan-600 text-white text-xs font-semibold">
                    <Play className="h-4 w-4 mr-1" /> Release
                  </Button>
                  <Button variant="outline" onClick={() => onDelete(sale.id)}
                    className="h-9 px-3 text-red-600 border-red-200 hover:bg-red-50">
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
